import classNames from 'classnames';
import { LabelBodySmall, LabelBreadcrumbsActive } from '../components';
import {
    PhoneFrameChatBubbleTip,
    PhoneFrameiPhone,
    PhoneFrameiPhoneBody,
} from '../icons';

type Props = {
    variant?: 'iPhone';
    message: string;
    class?: string;
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
};

const messageWeekdayFormat = Intl.DateTimeFormat('da-DK', {
    weekday: 'long',
});
const messageTimeFormat = Intl.DateTimeFormat('da-DK', {
    timeStyle: 'short',
});

function MessageTime({ date = new Date() }: { date?: Date }) {
    return (
        messageWeekdayFormat.format(date) + ' ' + messageTimeFormat.format(date)
    );
}

export function PhoneMessageView({
    variant = 'iPhone',
    message,
    class: _class,
    className,
    style,
    children,
}: Props) {
    return (
        <div
            className={classNames(_class, className, 'relative')}
            style={{
                ...style,
                width: '335px',
                padding: '70px 38px 40px 30px',
            }}
        >
            <div className="absolute inset-0 overflow-hidden">
                <PhoneFrameiPhoneBody className="absolute inset-0 grow" />
                <PhoneFrameiPhone className="absolute inset-0 bottom-auto bg-white" />
            </div>
            <div className="relative flex flex-col">
                <LabelBreadcrumbsActive class="text-center text-grey-750 first-letter:capitalize">
                    <MessageTime />
                </LabelBreadcrumbsActive>
                <div
                    className="relative whitespace-pre-wrap bg-message px-20 py-10 text-message"
                    style={{ borderRadius: '15px' }}
                >
                    <LabelBodySmall color="text-white">
                        {message}
                    </LabelBodySmall>
                    <PhoneFrameChatBubbleTip
                        className="absolute"
                        style={{ right: '-8px', bottom: '-1px' }}
                    />
                </div>
                <LabelBreadcrumbsActive class="text-end text-grey-750">
                    Leveret
                </LabelBreadcrumbsActive>

                {children}
            </div>
        </div>
    );
}
